import api from '../../api'

class NewsArticle {
  constructor({ title, articleDate, link, favorite }) {
    this.title = title
    this.articleDate = articleDate
    this.link = link
    this.favorite = favorite
  }
}

const state = {
  newsarticles: []
}

const mutations = {
  newsarticlesLoaded(state, payload = []) {
    state.newsarticles = payload.map(n => {
      return new NewsArticle({
        title: n.title,
        articleDate: n.article_date,
        link: n.link,
        favorite: n.favorite
      })
    })
  }
}

const actions = {
  async loadNewsArticles({ commit, rootState }) {
    rootState.loading = true
    const response = await api.getNewsArticles()
    const articles = response && response.data
    commit('newsarticlesLoaded', articles)
    rootState.loading = false
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
